export const shopList = [
    { id: 'DUNGEON_DICE', name: 'Dungeon Dice' },
    { id: 'PLAY_BAZAR', name: 'Play Bazar' },
    { id: 'IBS', name: 'IBS' },
    { id: 'GET_YOUR_FUN', name: 'Get Your Fun' },
    {id: 'MAGIC_MERCHANT', name: 'Magic Merchant'}
];